/**
 * NO04 - Ordre Search Models
 */

export interface NO04SearchParams {
  companyId: string;
  orderNumber?: string;
  customerNumber?: string;
  requisitionNumber?: string;
  productId?: string;
  invoiceCreditNumber?: string;
  receiver?: string;
  address?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  pageSize?: number;
}

export interface NO04Order {
  ordreNr: string;
  kundenr: string;
  navn: string;
  rekvNr: string;
  dato: string;
  tid: string;
  om: string;           // receiver
  status: string;
  antBestilt: number;
  antLevert: number;
  belop: number;
  brfProsent: number | null;   // grossProfit % — null if user lacks permission
  faktura: string;      // invoiceCreditNumber
  fraktEdi: string;     // shippingNumber (tracking)
  ordreType: string;
  betalingsKode: string;
  sendeMote: string;    // shippingMethod (O-SENDEMOTE description)
  speditor: string;     // carrier code from frakt_kostnadr.SPED (e.g. TP, NC, LG)
  bk: string;
}

export default class NO04 implements NO04Order {
  ordreNr: string;
  kundenr: string;
  navn: string;
  rekvNr: string;
  dato: string;
  tid: string;
  om: string;
  status: string;
  antBestilt: number;
  antLevert: number;
  belop: number;
  brfProsent: number | null;
  faktura: string;
  fraktEdi: string;
  ordreType: string;
  betalingsKode: string;
  sendeMote: string;
  speditor: string;
  bk: string;

  constructor(
    ordreNr = '',
    kundenr = '',
    navn = '',
    rekvNr = '',
    dato = '',
    tid = '',
    om = '',
    status = '',
    antBestilt = 0,
    antLevert = 0,
    belop = 0,
    brfProsent: number | null = null,
    faktura = '',
    fraktEdi = '',
    ordreType = '',
    betalingsKode = '',
    sendeMote = '',
    speditor = '',
    bk = '',
  ) {
    this.ordreNr = ordreNr;
    this.kundenr = kundenr;
    this.navn = navn;
    this.rekvNr = rekvNr;
    this.dato = dato;
    this.tid = tid;
    this.om = om;
    this.status = status;
    this.antBestilt = antBestilt;
    this.antLevert = antLevert;
    this.belop = belop;
    this.brfProsent = brfProsent;
    this.faktura = faktura;
    this.fraktEdi = fraktEdi;
    this.ordreType = ordreType;
    this.betalingsKode = betalingsKode;
    this.sendeMote = sendeMote;
    this.speditor = speditor;
    this.bk = bk;
  }
}

